export const saveBase64File = (reportName, byte) => {
    const dataString = `data:application/pdf;base64,${byte}`;
    const link = document.createElement('a');
    link.href = dataString;
    const fileName = reportName;
    link.download = fileName;
    link.click();
};